/*
 *   File : radio-group.js
 *   Author URI : www.evoqins.com
 *   Description : Radio group component
 *   Integrations : NA
 *   Version : v1.1
 */

import { useEffect, useState, useContext } from "react";
import { DarkModeContext } from "../../Context/dark-mode-context";
import Icon from "../Icon/icon";

const RadioGroup = (props) => {

    const { darkMode } = useContext(DarkModeContext);
    const [selectedValue, setSelectedValue] = useState(props.id);

    useEffect(() => {
        setSelectedValue(props.id);
    }, [props.id])

    const _handleClick = (item) => {
        if (props.type === 4) {
            setSelectedValue(item);
            props.radioHandler(item);
        } else {
            setSelectedValue(item.id);
            props.radioHandler(item.id,item.label);
        }
    }

    return (

        <div className={`${props.className} d-flex flex-wrap gap-8px`}>
            {
                props.data.map((item, key) => {
                    if (props.type === 1) {
                        let is_selected = selectedValue === item.id;
                        return (
                            <div key={key}
                                className={` cursor-pointer d-flex align-items-center ${props.radioItem ? props.radioItem : "w-100 mt-2"}`}
                                onClick={() => _handleClick(item)}>
                                <Icon className={props.iconClassName ? props.iconClassName : "me-4"}
                                    icon={is_selected ? 'radio-selected' : 'radio-unselected'}
                                    size={props.size ? props.size : 22} />
                                <span className={`e-font-sm-16-14 ${is_selected ? "color-primary-color" : darkMode === true ? "color-white" : "color-gray"} ${props.spanClass ? props.spanClass : "e-poppins-medium"}`}>
                                    {
                                        props.containesRupee === true ?
                                            item.label.split('').map((char, index) => (
                                                <span key={index} className={char === '₹' ? 'e-inter-regular' : 'e-poppins-regular'}>
                                                    {char}
                                                </span>
                                            )) :
                                            item.label
                                    }
                                </span>
                            </div>
                        )
                    }
                    else if (props.type === 3) {
                        let is_selected = selectedValue === item.id;
                        return (
                            <div key={key}
                                className={`d-flex gap-8px align-items-center cursor-pointer border-radius-8px border-all-1px padding-12px-all ${props.radioItemClassName}
                                ${is_selected ?
                                        `border-primary-color`
                                        :
                                        `border-bright-gray`
                                    }`}

                                onClick={() => _handleClick(item)}>
                                <Icon icon={
                                    is_selected ?
                                        'radio-selected' :
                                        'radio-unselected'
                                }
                                    size={props.size ? props.size : 24} />
                                <img src={item.image}
                                    alt={item.label}
                                    width={24}
                                    height={24} />
                                <span className={`${props.fontSize ? props.fontSize : "e-font-14"}
                                    ${is_selected ?
                                        `color-black e-poppins-semi-bold` :
                                        ` ${darkMode === true ? "color-white" : "color-charleston-green"} e-poppins-regular`
                                    }
                                `}>
                                    {item.label}
                                </span>
                            </div>
                        )
                    } else if (props.type === 4) {
                        let is_selected = selectedValue === item;
                        return (
                            <div key={key}
                                className={`d-flex gap-8px align-items-center cursor-pointer border-radius-8px border-all-1px padding-12px-all ${props.radioItemClassName}
                                ${is_selected ?
                                        `border-primary-color`
                                        :
                                        `border-bright-gray`
                                    }`}

                                onClick={() => _handleClick(item)}>
                                <Icon icon={
                                    is_selected ?
                                        'radio-selected' :
                                        'radio-unselected'
                                }
                                    size={props.size ? props.size : 24} />
                                <span className={`${props.fontSize ? props.fontSize : "e-font-14"}
                                    ${is_selected ?
                                        `color-black e-poppins-semi-bold` :
                                        `${darkMode === true ? "color-white" : "color-charleston-green"} e-poppins-regular`
                                    }
                                `}>
                                    {item}
                                </span>
                            </div>
                        )
                    }
                    else {
                        let is_selected = selectedValue === item.id;
                        return (
                            <div key={key}
                                className={`d-flex gap-8px align-items-center cursor-pointer border-radius-8px border-all-1px padding-12px-all position-relative ${props.radioItemClassName}
                                    ${is_selected ?
                                        `${props.activeClass ? props.activeClass : 'border-primary-color'}`
                                        :
                                        `border-bright-gray`
                                    }`}

                                onClick={() => _handleClick(item)}>
                                {
                                    props.recommendedBadge === true && item.id === 1 && (
                                        <div className={`e-bank-recommended-badge border-radius-8px bg-bubble-light  e-poppins-regular position-absolute e-font-10 h-max-content padding-2px-tb padding-4px-lr`}>
                                            Recommended
                                        </div>
                                    )
                                }
                                <Icon icon={
                                    is_selected ?
                                        'radio-selected' :
                                        'radio-unselected'
                                }
                                    size={props.size ? props.size : 24} />
                                <span className={`${props.fontSize ? props.fontSize : "e-font-14"}
                                ${is_selected ?
                                        `color-black e-poppins-semi-bold` :
                                        `${darkMode === true ? "color-white" : "color-charleston-green"} e-poppins-regular`
                                    }`}>
                                    {item.label}
                                </span>
                            </div>
                        )
                    }
                })
            }
        </div>

    )
}

export default RadioGroup;